import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { getRestaurantLeadByZipcodeAPI } from '../api-services/MarketingLead.service';

const MarketingLeadDataContext = createContext(null);

const initialMarketingLeadsRequest = {
  loading: true,
  data: null,
  success: null,
  errorMessage: '',
};

export function MarketingLeadDataProvider({ children }) {
  const [restaurantLeadsData, setRestaurantLeadsData] = useState(initialMarketingLeadsRequest);

  const markRestaurantLeadsSatisfiedWithoutFetch = useCallback(() => {
    setRestaurantLeadsData({
      loading: false,
      data: null,
      success: true,
      errorMessage: '',
    });
  }, []);

  const fetchRestaurantLeads = useCallback(async (params) => {
    setRestaurantLeadsData({
      loading: true,
      data: null,
      success: null,
      errorMessage: '',
    });

    try {
      const data = await getRestaurantLeadByZipcodeAPI(params);
      if (data.hasError) {
        setRestaurantLeadsData({
          loading: false,
          data: null,
          success: false,
          errorMessage: data.message || 'Failed to load marketing leads.',
        });
        return data;
      }

      const payload = data.data || {};
      const ok = payload.success === true;
      setRestaurantLeadsData({
        loading: false,
        data,
        success: ok,
        errorMessage: ok
          ? ''
          : payload.CustomMessage || payload.message || 'Could not load marketing lead list.',
      });
      return data;
    } catch (error) {
      console.log('fetchRestaurantLeads catch', error);
      setRestaurantLeadsData({
        loading: false,
        data: null,
        success: false,
        errorMessage: error?.message || 'Failed to load marketing leads.',
      });
      return { hasError: true, message: error?.message };
    }
  }, []);

  const value = useMemo(
    () => ({
      restaurantLeadsData,
      fetchRestaurantLeads,
      markRestaurantLeadsSatisfiedWithoutFetch,
    }),
    [restaurantLeadsData, fetchRestaurantLeads, markRestaurantLeadsSatisfiedWithoutFetch]
  );

  return (
    <MarketingLeadDataContext.Provider value={value}>{children}</MarketingLeadDataContext.Provider>
  );
}

export function useMarketingLeadData() {
  const ctx = useContext(MarketingLeadDataContext);
  if (ctx == null) {
    throw new Error('useMarketingLeadData must be used within MarketingLeadDataProvider');
  }
  return ctx;
}
